import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { getLocalStorageItem } from 'hooks';
import { useAuthMe } from 'queries/AuthQueries';
import {
  useDeactivatePatientAcconutApi,
  useDeactivateStaffUserAcconutApi,
} from 'queries/Patient';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface DeactivateAccountDialogProps {
  open: boolean;
  onClose: () => void;
}

const DeactivateAccountDialog: React.FC<DeactivateAccountDialogProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation('account');
  const navigate = useNavigate();
  const { data: profileData } = useAuthMe();
  const [timer, setTimer] = useState(10);
  const [showTimer, setShowTimer] = useState(false);
  const UserDetails = getLocalStorageItem('roles');
  const headerKeys = {
    'x-klynex-access-key':
      profileData?.data?.account?.patientsAccessKey ||
      UserDetails?.account?.patientsAccessKey,
  };
  const { mutate: deactivateUsers } =
    useDeactivatePatientAcconutApi(headerKeys);
  const { mutate: deactivateStaffUsers } = useDeactivateStaffUserAcconutApi();

  useEffect(() => {
    let interval: string | number | NodeJS.Timeout | null | undefined = null;
    if (showTimer && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      localStorage.clear();
      navigate('/');
    }
    return () => clearInterval(interval as any);
  }, [showTimer, timer, navigate, onClose]);

  const handleDeactivateUser = () => {
    const payload = {
      accountId: profileData.data.account.id,
      uuid: profileData.data.uuid,
    };
    const staffPayload = {
      uuid: profileData.data.uuid,
    };
    const onSuccess = () => {
      setShowTimer(true);
    };
    if (profileData?.data?.roles?.includes('patient')) {
      deactivateUsers(payload, { onSuccess });
    } else {
      deactivateStaffUsers(staffPayload as any, { onSuccess });
    }
  };

  return (
    <Dialog
      disableEscapeKeyDown
      open={open}
      aria-labelledby="deactivate-account-dialog-title"
      aria-describedby="deactivate-account-dialog-description"
      sx={{
        '& .MuiDialog-paper': {
          padding: '24px',
          borderRadius: '8px',
        },
      }}
      maxWidth="sm"
    >
      <div className="max-w-[500px]">
        <DialogTitle
          id="deactivate-account-dialog-title"
          sx={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#333',
          }}
        >
          {showTimer
            ? t('accountDeactivated')
            : t('confirmAccountDeactivation')}
        </DialogTitle>
        <DialogContent sx={{ marginTop: '8px' }}>
          {showTimer ? (
            <Typography className="text-center text-sm">
              {t('deactivatedYourAccount')}&nbsp;
              {/* <span className="text-lg font-bold">{timer}</span> */}
              {t('thankYouBeing')}
            </Typography>
          ) : (
            <Typography
              sx={{ textAlign: 'center', fontSize: '1rem', color: '#666' }}
            >
              {t('deactivateNotReversible')}
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', padding: '20px 24px' }}>
          {!showTimer && (
            <>
              <Button
                onClick={onClose}
                sx={{
                  fontWeight: 'bold',
                  textTransform: 'none',
                  borderRadius: '20px',
                  // width: '150px',
                }}
                variant="outlined"
                color="primary"
              >
                {t('noCancelIt')}
              </Button>
              <Button
                onClick={handleDeactivateUser}
                sx={{
                  fontWeight: 'bold',
                  textTransform: 'none',
                  borderRadius: '20px',
                  // width: '150px',
                }}
                variant="contained"
                color="error"
                autoFocus
              >
                {t('yesDeactivate')}
              </Button>
            </>
          )}
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default DeactivateAccountDialog;
